module.exports = __webpack_public_path__ + "img/Infografis_EN_14.0c6be13b.jpg";